import styles from "./Disclaimer.module.css";

function Disclaimer({ noAuth = true }) {
  return (
    <div>
      {noAuth && (
        <header className={styles.disclaimerPageHeading}>
          <div className={styles.disclaimerPageHeadingContainer}>
            <a href="/">
              <span className={styles.logoWrapper}>
                <span className={styles.logoSizer}>
                  <img
                    className={styles.logoSpacer}
                    alt=""
                    aria-hidden="true"
                    src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2785%27%20height=%2741%27/%3e"
                  />
                </span>
                <img
                  className={styles.logoImage}
                  alt="Irish Funds Logo"
                  srcSet="/assets/img/irish-funds1.png?_w=85 1x, /assets/img/irish-funds1.png?_w=85 2x"
                  src="/assets/img/irish-funds1.png?_w=85"
                  decoding="async"
                />
              </span>
            </a>
            <div className={styles.disclaimerHeaderButtons}>
              <a className={styles.disclaimerHeaderButtonLogIn} href="/auth/login/">
                Log in
              </a>
            </div>
          </div>
        </header>
      )}
      <section
        className={`${styles.memberportalsectiondisclaimer} ${styles.disclaimersection}`}
      >
        <div className={styles.disclaimerContainer}>
          <h1 className={styles.disclaimerHeading}>Disclaimer</h1>
          <div className={styles.disclaimerGrid}>
            <div className={styles.disclaimerContent}>
              <p>Member Portal and AI Assistant (Daire) Terms & Conditions</p>
              <p>
                The Irish Funds Member Portal ("the Portal") is a secure,
                members-only platform designed to provide access to resources,
                information, and updates relevant to the Irish funds industry.
                Access to and use of the Portal is strictly limited to staff of
                Irish Funds member firms.
              </p>
              <p>
                Please read the following terms carefully. By using the Portal,
                you acknowledge and agree to the terms outlined below:
              </p>
              <p>1. Access and Confidentiality</p>
              <ul>
                <li>
                  All materials provided through the Portal are intended solely
                  for the internal use of member firms.
                </li>
                <li>
                  Content is private, confidential, and must not be shared
                  externally without prior authorisation from Irish Funds.
                </li>
                <li>
                  Members are responsible for maintaining the confidentiality of
                  any information accessed through the Portal.
                </li>
                <li>
                  Sharing Working Group member details outside the Irish Funds
                  member network is prohibited without prior authorisation from
                  Irish Funds.
                </li>
              </ul>
              <p>2. Nature of Information</p>
              <ul>
                <li>
                  The Portal provides general information for reference purposes
                  only.
                </li>
                <li>
                  Content is provided "as is" and does not constitute legal, tax,
                  investment, accounting, financial, or professional advice.
                </li>
                <li>
                  Users should seek qualified professional advice before acting on
                  any information obtained from the Portal.
                </li>
              </ul>
              <p>3. Accuracy and Updates</p>
              <ul>
                <li>
                  While Irish Funds aims to provide accurate and up-to-date
                  content, no guarantees are made regarding completeness,
                  reliability, or timeliness.
                </li>
                <li>
                  Access to the Portal may be temporarily unavailable due to
                  maintenance or technical issues.
                </li>
                <li>
                  Irish Funds is not liable for any loss or damage resulting from
                  reliance on information contained within the Portal.
                </li>
              </ul>
              <p>4. Member Contributions</p>
              <ul>
                <li>
                  Any content or material uploaded by a member is provided "as
                  is," and Irish Funds makes no warranties regarding its accuracy,
                  security, or suitability.
                </li>
                <li>
                  Members remain responsible for ensuring that any contributions
                  do not infringe third-party rights or breach any applicable
                  laws.
                </li>
              </ul>
              <p>5. Monitoring and Content Management</p>
              <ul>
                <li>
                  Irish Funds reserves the right to monitor, edit, or remove
                  content on the Portal at its discretion.
                </li>
                <li>
                  While there is no obligation to screen all material, a "notice
                  and takedown" approach is in place.
                </li>
                <li>
                  If you believe any content infringes rights or is otherwise
                  inappropriate, please notify Irish Funds immediately via
                  memberportal@irishfunds.ie.
                </li>
              </ul>
              <p>6. Limitation of Liability</p>
              <ul>
                <li>Use of the Portal is at your own risk.</li>
                <li>
                  To the fullest extent permitted by law, Irish Funds and its
                  member firms accept no responsibility for any direct, indirect,
                  or consequential loss arising from your use of the Portal or
                  reliance on its content.
                </li>
              </ul>
              <p>7. Legal Framework</p>
              <ul>
                <li>
                  These Terms & Conditions are governed by the laws of Ireland.
                </li>
                <li>
                  Irish Funds may update these terms from time to time. Continued
                  use of the Portal signifies your acceptance of the most recent
                  version.
                </li>
              </ul>
              <p>
                AI Assistant (ChatGPT) - By using this service, you acknowledge
                and consent to the following:
              </p>
              <ol>
                <li>
                  Use of Data: Your interactions with the AI Assistant may be
                  monitored and stored by Irish Funds for quality assurance,
                  service improvement, and trend analysis. This data is not used
                  to train the AI model, and no personal data is shared with
                  OpenAI or external third parties.
                </li>
                <li>
                  Nature of Information Provided: The AI Assistant provides
                  general, non-binding information based on curated datasets. It
                  does not constitute legal, tax, accounting, or financial advice.
                  Daire will prioritise Irish Funds curated information when
                  responding but may provide information from its existing corpus
                  of knowledge.
                </li>
                <li>
                  Responsibility: You remain responsible for verifying any
                  information provided and for taking appropriate professional
                  advice where necessary. The system will provide you with a list
                  of information sources that were used in the generation of the
                  response.
                </li>
                <li>
                  Privacy and Security: All interactions are subject to the Irish
                  Funds Privacy Policy. Please review our full{" "}
                  <a href="https://www.irishfunds.ie/privacy/">Privacy Policy</a>.
                </li>
                <li>
                  Support and Reporting Issues: For concerns or to report
                  inaccurate responses, contact{" "}
                  <a href="mailto:memberportal@irishfunds.ie">
                    memberportal@irishfunds.ie
                  </a>
                  .
                </li>
              </ol>
            </div>
            <div>
              <article className={styles.gatewayCard}>
                <h2>Contact Details</h2>
                <p>Irish Funds Ashford House, Tara St, Dublin 2, D02 VX67</p>
                <p>
                  T:{" "}
                  <a target="_self" href="tel:+353 (0) 1 675 3200">
                    +353 (0) 1 675 3200
                  </a>
                </p>
                <p>
                  F:{" "}
                  <a target="_self" href="tel:+353 (0) 1 675 3210">
                    +353 (0) 1 675 3210
                  </a>
                </p>
                <p>
                  E:{" "}
                  <a href="mailto:memberportal@irishfunds.ie">
                    memberportal@irishfunds.ie
                  </a>
                </p>
              </article>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Disclaimer;
